import defer from 'lodash/defer';
import {
  initObserveStore,
  observeStore,
  utils,
  focusTrap,
} from '@resy/ui-kitchen';
import getConnectedActions from '../../modules/actions/connectedActions';
import { setSelectedLocationThunk } from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { ISO_DATE_FORMAT } from '../../../../ui-kitchen/src/constants/resyCore';
import {
  getSelectedCoreISODateThunk, getSelectedCoreSeatsThunk, getSelectedCoreTimeThunk, setSelectedCoreISODate, setSelectedCoreSeats, setSelectedCoreTime,
} from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import {
  getUserThunk, selectIsConcierge, selectIsGlobalDiningAccess, userLogoutThunk,
} from '../../../../ui-kitchen/src/reducers/userSlice';
import getLatLng from '../../../../ui-kitchen/src/utils/getLatLngThunk';
import { CTA_EVENT_NAME } from '../../modules/components/AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../modules/components/AmexMarketingUtils/AmexUtils';

angular.module('resyApp')
  .component('resyAmex', {
    templateUrl: 'components/amex/amex.html',
    controller: AmexCtrl,
    controllerAs: 'vm',
    bindings: {
      active: '<',
    },
  });

function AmexCtrl($rootScope, $scope, Analytics, $location, $window) {
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */
  const vm = this;
  const store = $rootScope.reduxStore;
  const { dispatch, getState } = store;
  const {
    fetchMarketingCollections,
  } = getConnectedActions(dispatch);

  vm.collections = [];
  vm.$onInit = onInit;
  vm.showSignupModal = showSignupModal;
  vm.showAuthModal = showAuthModal;
  vm.onLogin = onLogin;
  vm.loadNotifyModal = loadNotifyModal;

  vm.selectedDate = null;
  vm.selectedPartySize = null;
  vm.selectedLocation = undefined;
  vm.locationCode = null;
  vm.isAuthenticated = selectIsAuthenticated(getState());
  vm.containerQuery = $rootScope.matchMedia;

  // Header starts
  const { venueInventoryUtils } = utils;

  // Controls the display for all nav elements
  vm.dropdowns = {
    date: false,
    locations: false,
    menu: false,
    search: false,
    seats: false,
  };
  vm.isBackdropOpen = false;
  vm.showTimeFilter = true;

  // Location related
  vm.locations = [];
  vm.selectedLocation = null;
  vm.shouldHideLocation = false;

  // Auth/User related
  vm.isLoggedIn = false;
  vm.profilePhotoUrl = null;
  vm.isGda = false;
  vm.isConciergeUser = false;

  // Date & Seats
  // vm.searchFields is legacy at this point and should be refactored
  // I refactored out 'quantityStepper', so just 'datepicker' is left
  vm.searchFields = {
    datepicker: {
      model: null,
      config: {
        label: 'Pick a Date',
        calendarNumber: {
          default: 1,
          lg: 2,
        },
        calendarLeadDays: null,
      },
    },
  };
  vm.selectedSeats = null;
  vm.selectedTime = null;
  vm.calendar = null;

  vm.onDateSelect = onDateSelectDelta;
  vm.onLogoClick = onLogoClickDelta;
  vm.onPartySizeChange = onPartySizeChange;
  vm.onPartySizeClick = onPartySizeClick;
  vm.onTimeChange = onTimeChange;
  vm.onTimeClick = onTimeClick;
  vm.toggleCalendar = toggleCalendar;
  vm.toggleMenu = toggleMenuDelta;
  vm.closeEverything = closeEverythingDelta;
  vm.onLoginDelta = onLoginDelta;
  vm.onLogoutDelta = onLogoutDelta;
  vm.getAriaLabel = venueInventoryUtils.getAriaLabel;
  vm.clickableElementIdsToIgnore = ['DateSelector__button'];
  $rootScope.searchProps = {
    onPartySizeChange,
    onPartySizeClick,
    onTimeChange,
    onTimeClick,
    toggleCalendar,
    dropdowns: vm.dropdowns,
    searchFields: vm.searchFields,
    selectedSeats: vm.selectedSeats,
    selectedTime: vm.selectedTime,
  };

  vm.latLng = null;
  vm.setDeltaPageLocation = setDeltaPageLocation;
  // ends
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */

  function isDeltaWifi(active) {
    return active === 'delta-wifi';
  }

  function setSelectedDateProps(selectedCoreISODate) {
    // vm.selectedDate is in ISO Date format
    // vm.activeMonthMomentObject is a Moment object
    // vm.searchFields.datepicker.model is a Date object
    // vm.selectedDateFormatted is in ISO Date format
    // vm.searchFields.datepicker.config.label is in Calendar format
    vm.selectedDate = selectedCoreISODate;
    vm.searchFields.datepicker.model = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
    vm.selectedDateFormatted = selectedCoreISODate;
    vm.activeMonthMomentObject = moment(selectedCoreISODate, ISO_DATE_FORMAT);
    vm.searchFields.datepicker.config.label = moment(selectedCoreISODate, ISO_DATE_FORMAT).calendar();
  }

  function onInit() {
    if (vm.active === 'amex-gdadir' || vm.active === 'amex-gda' || vm.active === 'amex-gda-member') {
      setupReactors();
    }

    if (vm.active === 'delta-wifi') {
      closeEverythingDelta();
      loadUserDelta();
      loadDateDelta();
      loadPartySizeDelta();
      setMonthValuesDelta();
      loadLatLngDelta();
      loadTime();
    }
  }

  const onCollectionsSliceChange = async (collections) => {
    const { lists: { marketing } } = collections;
    const key = 'ny-1';
    if (!marketing[key]) {
      fetchMarketingCollections({ location_id: 'ny', include_algo: 1 });
    } else {
      vm.collections = marketing[key].all || [];
    }
    defer(() => $scope.$apply());
  };

  const unsubscribeCollectionsSlice = observeStore(
    store,
    ({ collections }) => (collections),
    onCollectionsSliceChange
  );

  const onResyCoreSliceChange = (resyCoreSlice) => {
    const { selectedCoreISODate, selectedCoreSeats, selectedCoreTime } = resyCoreSlice;

    if (isDeltaWifi(vm.active) && vm.selectedDate !== selectedCoreISODate) {
      setSelectedDateProps(selectedCoreISODate);
    }

    if (isDeltaWifi(vm.active) && vm.selectedPartySize !== selectedCoreSeats) {
      vm.selectedPartySize = selectedCoreSeats;
      vm.selectedSeats = selectedCoreSeats;
      $rootScope.searchProps.selectedSeats = selectedCoreSeats;
    }

    // SELECTED_TIME_UPDATED handling
    if (isDeltaWifi(vm.active) && vm.selectedTime !== selectedCoreTime) {
      vm.selectedTime = selectedCoreTime;
      $rootScope.searchProps.selectedTime = vm.selectedTime;
    }
    defer(() => $scope.$apply());
  };
  const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
  const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

  let prevUserData = null;
  const onUserSliceChange = (userSlice) => {
    const { userData } = userSlice;
    const isAuth = selectIsAuthenticated(getState());
    vm.isLoggedIn = isAuth;
    vm.isAuthenticated = isAuth;
    vm.isGda = selectIsGlobalDiningAccess(getState());
    vm.isConciergeUser = selectIsConcierge(getState());

    // Angular 'UserAuth' event handling
    if (prevUserData === null && userData) {
      vm.profilePhotoUrl = userData.profile_image_url;
      closeEverythingDelta();
    }

    // Angular 'UserLogout' event handling
    if (prevUserData && userData === null) {
      vm.profilePhotoUrl = null;
    }

    prevUserData = userData;
    defer(() => $scope.$apply());
  };

  const observeUserSlice = initObserveStore(store, ({ user }) => (user));
  const unsubscribeUserSlice = observeUserSlice(onUserSliceChange);

  function setupReactors() {
    $scope.$on('$destroy', () => {
      unsubscribeCollectionsSlice();
      unsubscribeResyCoreSlice();
      unsubscribeUserSlice();
    });
  }

  function showSignupModal() {
    $rootScope.$broadcast('MODAL', 'signup');
  }

  function onLogin() {
    Analytics.event('Login button clicked', {
      category: 'User',
      label: 'resy.com',
    });
    $rootScope.$broadcast('MODAL', 'signin');
  }

  function showAuthModal(successCallback) {
    $rootScope.$broadcast('MODAL', 'signin', { successCallback });
  }

  function loadNotifyModal({
    activeNotifications,
    selectedDate,
    selectedQuantity,
    notifyService,
    venueId,
    venueName,
  }) {
    // needed to normalize the start and end values for the notify modal
    const normalizedActiveNotifications = {};
    Object.keys(activeNotifications).forEach((item) => {
      const {
        time_preferred_end, // eslint-disable-line camelcase
        time_preferred_start, // eslint-disable-line camelcase
        ...args
      } = activeNotifications[item];

      normalizedActiveNotifications[item] = {
        ...args,
        end: time_preferred_end,
        start: time_preferred_start,
      };
    });

    $rootScope.$broadcast('MODAL', 'notify', {
      activeNotifications: normalizedActiveNotifications,
      locationSlug: vm.locationSlug,
      selectedDate,
      selectedQuantity,
      notifyService,
      venueId,
      venueName,
    });
  }

  function loadTime() {
    const time = dispatch(getSelectedCoreTimeThunk());
    vm.selectedTime = (time !== 'all-day') ? time : null;
    $location.search('time', vm.selectedTime).replace();
  }

  // DeltaWifi Header starts

  function onDateSelectDelta(selectedDate) {
    // selectedDate is a Moment object
    const selectedISODate = selectedDate.format(ISO_DATE_FORMAT);
    dispatch(setSelectedCoreISODate(selectedISODate));
    onDropdownClickDelta('date');
  }

  function onLogoClickDelta() {
    Analytics.event(CTA_EVENT_NAME, {
      action_name: 'Header Resy Logo - Click',
    });
    $location.path('/');
    closeEverythingDelta();
  }

  function onPartySizeChange({ party_size: quantity }) {
    const previousQuantity = vm.selectedSeats;
    if (!previousQuantity) return;
    if (String(previousQuantity) !== quantity) {
      dispatch(setSelectedCoreSeats(quantity));
      closeEverythingDelta();
      defer(() => $scope.$apply());
    }
  }

  function onPartySizeClick() {
    onDropdownClickDelta('seats');
    defer(() => $scope.$apply());
  }

  function onTimeClick() {
    onDropdownClickDelta('time');
    defer(() => $scope.$apply());
  }

  async function onTimeChange({ time }) {
    if (time === null) return;
    const previousTime = vm.selectedTime;
    if (String(previousTime) !== time) {
      dispatch(setSelectedCoreTime(time));
      closeEverythingDelta();
      defer(() => $scope.$apply());
    }
  }

  function onDropdownClickDelta(dropdown) {
    Object.keys(vm.dropdowns).forEach((key) => {
      if (key === dropdown) {
        const shouldOpen = !vm.dropdowns[key];
        vm.dropdowns[key] = shouldOpen;
        vm.isBackdropOpen = shouldOpen;
        $rootScope.isBackdropOpen = shouldOpen;

        if (shouldOpen) {
          if (dropdown === 'seats') {
            vm.isBackdropOpen = false;
            $rootScope.isBackdropOpen = false;
          } else if (dropdown === 'menu') {
            const isDesktop = document.querySelector('.MenuContainer--desktop');
            if (isDesktop) {
              focusTrap.focusModal(
                '.MenuContainer__menu-and-auth-button'
              );
            }
          }
          defer(() => $scope.$apply());
        } else {
          focusTrap.focusRemove();
          $rootScope.$digest();
          if (dropdown === 'date') {
            // the date button re-renders, need a delay before setting focus
            setTimeout(() => document.querySelector('.ResyNavDelta button.DateSelector').focus(), 350);
          }
        }
      } else {
        vm.dropdowns[key] = false;
      }
    });
  }

  function toggleCalendar() {
    onDropdownClickDelta('date');
    // race condition, activeDate does not exist first time it is called. timeout gives it time to render for ada requirements. can be removed when react calendar is used instead
    setTimeout(handleFocusDelta, 350);
  }

  function handleFocusDelta() {
    const calendarContainer = document.querySelector('#ResyNavDelta__calendar-dialog');
    const activeDate = document.querySelector('#active-date');

    if (calendarContainer && activeDate) {
      activeDate.focus();
    } else if (calendarContainer) {
      calendarContainer.focus();
    }
  }

  function toggleMenuDelta() {
    onDropdownClickDelta('menu');
    defer(() => $scope.$apply());
  }

  function closeEverythingDelta() {
    Object.keys(vm.dropdowns).forEach((key) => { vm.dropdowns[key] = false; });
    vm.isBackdropOpen = false;
    $rootScope.isBackdropOpen = false;
    focusTrap.focusRemove();
  }

  function onLoginDelta(pageName) {
    if (pageName !== 'delta') {
      handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, {
        action_name: 'Header Login - Click',
      }, () => $rootScope.$broadcast('MODAL', 'signin'));
    } else {
      $rootScope.$broadcast('MODAL', 'signin');
    }
  }

  function onLogoutDelta() {
    dispatch(userLogoutThunk());
    closeEverythingDelta();
  }

  function setDeltaPageLocation(location) {
    vm.selectedLocation = location;
    vm.shouldHideLocation = location?.hideMenu;
    vm.locationCode = location.code;
    vm.locationSlug = location.url_slug;
    vm.locationTier = location.content_tier;
    const params = {
      location,
      $rootScope,
      $window,
    };
    dispatch(setSelectedLocationThunk(params));
    closeEverythingDelta();
  }

  function setMonthValuesDelta(activeMonth) {
    const selectedMonth = activeMonth || moment(vm.selectedDateFormatted);
    const todaysDate = moment();
    vm.activeMonthMomentObject = moment(selectedMonth);

    vm.inventoryByDay = venueInventoryUtils.getDateRange(todaysDate);

    defer(() => $scope.$apply());
  }

  function loadUserDelta() {
    dispatch(getUserThunk(true));
  }

  function loadDateDelta() {
    const selectedCoreISODate = dispatch(getSelectedCoreISODateThunk());
    setSelectedDateProps(selectedCoreISODate);
  }

  function loadPartySizeDelta() {
    const selectedCoreSeats = dispatch(getSelectedCoreSeatsThunk());
    vm.selectedSeats = selectedCoreSeats;
    vm.selectedPartySize = selectedCoreSeats;
  }
  // DeltaWifi Header ends

  // Added for DeltaWifi Book Now

  function loadLatLngDelta() {
    dispatch(getLatLng()).then((latLng) => {
      vm.latLng = latLng;
      defer(() => $scope.$apply());
    });
  }
}

export default () => { };
